import './elm_google_translate'

// polyfill
import '@ungap/custom-elements'

// Shared components for all pages
import { initHeader } from './components/header'
import './components/remote_content'
import './components/lazy_svg_sprite'
import { initModal as initOldModal } from './components/modal'

document.addEventListener('DOMContentLoaded', () => {
  initOldModal()
  initHeader()
})
